import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, Zap, Clock, ArrowRight } from 'lucide-react';
import { EbookMockup } from './EbookMockup';
export function OfferSection() {
  return <section id="offer" className="py-24 bg-white" data-id="element-165">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-166">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-167">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-50 border border-red-200 text-red-600 font-semibold text-sm mb-6" data-id="element-168">
            <Clock className="w-4 h-4" data-id="element-169" />
            OFERTA POR TIEMPO LIMITADO
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-brand-black mb-4" data-id="element-170">
            Acceso inmediato al sistema completo
          </h2>
          <p className="text-lg text-gray-600" data-id="element-171">
            Todo lo que necesitas para dominar tu crédito hoy mismo.
          </p>
        </motion.div>

        <div className="bg-white rounded-3xl shadow-premium border-2 border-brand-gold/30 overflow-hidden max-w-4xl mx-auto flex flex-col md:flex-row" data-id="element-172">
          {/* Left Side - Visual */}
          <div className="bg-brand-gray p-8 md:p-12 flex flex-col items-center justify-center md:w-2/5 border-b md:border-b-0 md:border-r border-gray-200" data-id="element-173">
            <EbookMockup className="scale-90 md:scale-100 mb-6" data-id="element-174" />
            <div className="flex gap-4 justify-center mb-6" data-id="element-175">
              <img src="https://cdn.magicpatterns.com/uploads/nuVUfARUKGq3eMFr4UiEUk/ChatGPT_Image_24_abr_2026,_19_36_33.png" alt="Kit de Herramientas Crediticias" className="w-40 sm:w-48 h-auto drop-shadow-lg" data-id="element-176" />
              <img src="https://cdn.magicpatterns.com/uploads/4RceXW5NBDhBwNBpMeeajH/ChatGPT_Image_24_abr_2026,_19_46_34.png" alt="Guía Inteligente para Tarjetas de Crédito en USA" className="w-40 sm:w-48 h-auto drop-shadow-lg" data-id="element-177" />
            </div>
            <div className="flex items-center gap-2 text-brand-green font-semibold" data-id="element-178">
              <Zap className="w-5 h-5 text-brand-gold" data-id="element-179" />
              <span data-id="element-180">Acceso Digital Instantáneo</span>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="p-8 md:p-12 md:w-3/5 flex flex-col justify-center" data-id="element-181">
            <h3 className="text-2xl font-bold text-brand-black mb-6" data-id="element-182">
              ¿Qué te llevas hoy?
            </h3>

            {/* Items with prices */}
            <div className="space-y-4 mb-8" data-id="element-183">
              <div className="flex items-start justify-between gap-3 pb-3 border-b border-gray-100" data-id="element-184">
                <div className="flex items-start gap-3" data-id="element-185">
                  <div className="mt-1 bg-brand-green/10 rounded-full p-1" data-id="element-186">
                    <Check className="w-4 h-4 text-brand-green" data-id="element-187" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-188">
                    Sistema SCORE 700 Completo (20 Módulos)
                  </span>
                </div>
                <span className="text-gray-400 line-through text-sm whitespace-nowrap" data-id="element-189">
                  $49.00
                </span>
              </div>

              <div className="flex items-start justify-between gap-3 pb-3 border-b border-gray-100" data-id="element-190">
                <div className="flex items-start gap-3" data-id="element-191">
                  <div className="mt-1 bg-brand-green/10 rounded-full p-1" data-id="element-192">
                    <Check className="w-4 h-4 text-brand-green" data-id="element-193" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-194">
                    Bono #1: Kit de Herramientas Crediticias
                  </span>
                </div>
                <span className="text-gray-400 line-through text-sm whitespace-nowrap" data-id="element-195">
                  $19.99
                </span>
              </div>

              <div className="flex items-start justify-between gap-3 pb-3 border-b border-gray-100" data-id="element-196">
                <div className="flex items-start gap-3" data-id="element-197">
                  <div className="mt-1 bg-brand-green/10 rounded-full p-1" data-id="element-198">
                    <Check className="w-4 h-4 text-brand-green" data-id="element-199" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-200">
                    Bono #2: Guía Inteligente para Tarjetas de Crédito en USA
                  </span>
                </div>
                <span className="text-gray-400 line-through text-sm whitespace-nowrap" data-id="element-201">
                  $19.99
                </span>
              </div>

              <div className="flex items-start gap-3 pb-3 border-b border-gray-100" data-id="element-202">
                <div className="mt-1 bg-brand-green/10 rounded-full p-1" data-id="element-203">
                  <Check className="w-4 h-4 text-brand-green" data-id="element-204" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-205">
                  Formato digital de lectura fácil
                </span>
              </div>

              <div className="flex items-start gap-3" data-id="element-206">
                <div className="mt-1 bg-brand-green/10 rounded-full p-1" data-id="element-207">
                  <Check className="w-4 h-4 text-brand-green" data-id="element-208" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-209">
                  Acceso de por vida a futuras actualizaciones
                </span>
              </div>
            </div>

            {/* Pricing */}
            <div className="bg-brand-gray rounded-xl p-6 mb-6 text-center" data-id="element-210">
              <p className="text-sm text-gray-500 mb-1" data-id="element-211">Valor total:</p>
              <p className="text-2xl text-gray-400 line-through mb-2" data-id="element-212">$88.98</p>
              <p className="text-sm text-brand-green font-semibold mb-1" data-id="element-213">
                Precio por tiempo limitado:
              </p>
              <p className="text-5xl font-bold text-brand-green" data-id="element-214">
                $14<span className="text-3xl" data-id="element-215">.99</span>
              </p>
              <p className="text-xs text-gray-500 mt-2" data-id="element-216">
                Pago único · Sin suscripciones
              </p>
            </div>

            <div className="mt-auto" data-id="element-217">
              <motion.button onClick={() => window.open('https://e8br1p-v6.myshopify.com/cart/53210025689199:1', '_blank', 'noopener,noreferrer')} className="w-full py-5 bg-brand-green hover:bg-brand-green/90 text-white rounded-xl font-bold text-xl transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 flex items-center justify-center gap-3" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} data-id="element-218">
                <span data-id="element-219">ACCEDER AHORA POR $14.99</span>
                <ArrowRight className="w-6 h-6" data-id="element-220" />
              </motion.button>
              <p className="text-center mt-3 text-xs text-gray-400 flex items-center justify-center gap-1" data-id="element-221">
                <Lock className="w-3 h-3" data-id="element-222" /> Pago 100% Seguro · Acceso inmediato
                después del pago
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}